import { useTranslation } from "react-i18next";
import { Pause, Play, Trash2 } from "lucide-react";
import { NeuButton, NeuInput } from "../../components/neu/Neu";
import { CompanyActivationButton } from "./CompanyActivationButton";

// Limit input + suspend/delete/resend actions for one company card.
export const CompanyActions = ({ company, patch, onArchive, reload, visible }) => {
  const { t } = useTranslation();
  const suspended = company.status === "suspended";

  return (
    <div className={`mt-4 flex flex-wrap items-end gap-2 ${visible ? "" : "hidden"}`}>
      <div className="w-24">
        <p className="label-xs mb-1">{t("platform.maxEmployees")}</p>
        <NeuInput
          data-testid={`company-limit-${company.id}`}
          type="number"
          defaultValue={company.max_employees}
          onBlur={(e) => patch({ max_employees: Number(e.target.value) })}
        />
      </div>
      <NeuButton
        data-testid={`company-delete-${company.id}`}
        variant="danger"
        className="px-3 py-2"
        onClick={onArchive}
      >
        <Trash2 className="h-4 w-4" />
      </NeuButton>
      <NeuButton
        data-testid={`company-toggle-${company.id}`}
        variant={suspended ? "primary" : "danger"}
        className="flex items-center gap-2"
        onClick={() => patch({ status: suspended ? "active" : "suspended" })}
      >
        {suspended ? <Play className="h-4 w-4" /> : <Pause className="h-4 w-4" />}
        {suspended ? t("platform.activate") : t("platform.suspend")}
      </NeuButton>
      <CompanyActivationButton company={company} reload={reload} />
    </div>
  );
};
